import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowLeft } from 'lucide-react';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

const ThankYou = () => {
  return (
    <div className="min-h-screen bg-[#EDECEA] flex flex-col" data-testid="thank-you-page">
      <Navigation onWaitlistClick={() => {}} />

      <div className="flex-1 flex items-center justify-center px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-lg"
        >
          <CheckCircle className="w-16 h-16 text-[#C4A35A] mx-auto mb-6" />

          <h1
            className="font-['Playfair_Display'] text-4xl font-semibold text-[#0F1B2D] mb-4"
            data-testid="thank-you-heading"
          >
            You're on the Waitlist
          </h1>

          <p className="text-[#4A4640] font-medium leading-relaxed mb-8">
            Thank you for your interest in AINAA membership. A trusted existing member will verify your credentials before your application can be accepted.
          </p>

          <div className="inst-card rounded-lg p-6 mb-8 text-left">
            <h3 className="text-xs uppercase tracking-[0.2em] text-[#9B9589] font-bold mb-4">
              What happens next
            </h3>
            <ul className="space-y-3">
              {[
                'A trusted AINAA member will be matched to verify your credentials',
                'You will be notified by email once verification is complete',
                'If approved, you will receive your membership and Trust Score within 7 days',
              ].map((item, idx) => (
                <li key={item} className="flex items-start gap-3">
                  <div className="w-5 h-5 rounded bg-[#0F1B2D]/5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-[10px] font-bold text-[#0F1B2D]">{idx + 1}</span>
                  </div>
                  <span className="text-sm font-medium text-[#4A4640]">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <Link
            to="/"
            className="btn-ainaa-secondary inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold uppercase tracking-wider"
            data-testid="back-home-link"
          >
            <ArrowLeft size={16} />
            Return to AINAA
          </Link>
        </motion.div>
      </div>

      <Footer />
    </div>
  );
};

export default ThankYou;
